import { render, staticRenderFns } from "./PaginationNavigationButton.vue?vue&type=template&id=0c747fa7&"
import script from "./PaginationNavigationButton.vue?vue&type=script&lang=ts&"
export * from "./PaginationNavigationButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports